<template>
  <ftw-base-modal :value="value" v-bind="$attrs" @input="input">
    <v-form ref="form" :value="valid" @input="validate" @submit.prevent="submit">
      <v-card>
        <v-card-title>
          <div class="headline flex xs12">{{ title }}</div>
          <div v-if="subtitle" class="subtitle-1">{{ subtitle }}</div>
        </v-card-title>
        <v-card-text class="overflow-y-auto" :style="{ 'max-height': cardTextMaxHeight }">
          <slot />
        </v-card-text>
        <v-card-actions>
          <slot name="actions" />
          <v-btn v-if="!hideCancelBtn" color="grey" :disabled="loading" :dark="!loading" @click="reset">{{
            $t('Cancel')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <template #activator="props">
      <slot v-bind="props" name="activator" />
    </template>
  </ftw-base-modal>
</template>

<script>
export default {
  name: 'FormModal',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: () => '',
    },
    valid: {
      type: Boolean,
      default: () => false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    hideCancelBtn: {
      type: Boolean,
      default: () => false,
    },
    cardTextMaxHeight: {
      type: [String, Number],
      default: () => undefined,
    },
  },
  methods: {
    input(v) {
      this.$emit('input', v)
    },
    reset() {
      this.$refs.form.resetValidation()
      this.$emit('input', false)
    },
    submit() {
      this.$emit('submit')
    },
    validate(v) {
      this.$emit('update:valid', v)
      this.$emit('validate', v)
    },
  },
}
</script>
